import useMaskedInput from './utils/useMaskedInput';
import MaskedInput from './components/MaskedInput';
export { useMaskedInput };
export default MaskedInput;